<template>
  <div class="discovery-root">
    <div class="discovery-hover-cover" v-if="item">
      <single-item :item="item" />
    </div>
  </div>
</template>

<script>
import SingleItem from '@/components/displays/SingleItem.vue';
/**
 * Example use:
 *
 * Discovery.vueLoader('HoverCover', '#target-dom-element', {
 *   cn: 185554,
 *   blurb: '<div>example blurb</div>',
 * });
 */

export default {
  name: 'HoverCover',
  data() {
    return {
      item: null,
      data: null,
      cn: this.$root.params.cn,
      blurb: this.$root.params.blurb,
      title: this.$root.params.title,
      mode: this.$root.params.mode ?? 'default',
    };
  },
  components: {
    SingleItem,
  },
  created() {
    this.JsPAPI.api.bibGet(this.cn).then((r) => {
      Discovery.log('Received item data');
      this.data = r.data;
      const p = this.JsPAPI.util.bibParser(r.data);
      this.item = this.JsPAPI.util.bibConverter(p, this.cn);
    });
  },
};

</script>

<style lang="less">
@import '~@/css/global';

</style>
